import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ShopContext } from '../Context/ShopContext';
import Breadcrums from '../Components/Breadcrums/Breadcrums';
import ProductDisplay from '../Components/ProductDisplay/ProductDisplay';
import DescriptionBox from '../Components/DescriptionBox/DescriptionBox';
import RelatedProducts from '../Components/RelatedProducts/RelatedProducts';

const Product = () => {
  
  const { all_product, addToCart } = useContext(ShopContext);
  const { productId } = useParams();
  const navigate = useNavigate();
  const [selectedSize, setSelectedSize] = useState('S');

  const product = all_product.find((e) => e.id === Number(productId));

  useEffect(() => {
    if (!product) {
      navigate('/');
    }
  }, [product, navigate]);

  if (!product) return null;

  return (
    <div>
      <Breadcrums product={product} />
      <ProductDisplay product={product} addToCart={() => addToCart(product.id, selectedSize)} selectedSize={selectedSize} setSelectedSize={setSelectedSize} />
      <DescriptionBox product={product} />
      <RelatedProducts />
    </div>
  );
};

export default Product;